var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServiceOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13C14.8954 13 14 13.8954 14 15V33C14 34.1046 14.8954 35 16 35H32C33.1046 35 34 34.1046 34 33V15C34 13.8954 33.1046 13 32 13H16ZM17 16C16.4477 16 16 16.4477 16 17C16 17.5523 16.4477 18 17 18H27C27.5523 18 28 17.5523 28 17C28 16.4477 27.5523 16 27 16H17ZM16 21C16 20.4477 16.4477 20 17 20H27C27.5523 20 28 20.4477 28 21C28 21.5523 27.5523 22 27 22H17C16.4477 22 16 21.5523 16 21ZM17 24C16.4477 24 16 24.4477 16 25C16 25.5523 16.4477 26 17 26H23C23.5523 26 24 25.5523 24 25C24 24.4477 23.5523 24 23 24H17Z",
    fill: "#363A4D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOrder);
export default __webpack_public_path__ + "static/media/service_order.cbe6c3912db2daa11414127a06c322df.svg";
export { ForwardRef as ReactComponent };